
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 61.6 10.09"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticStyle:{"isolation":"isolate"},attrs:{"data-name":"-e-iconTimerStyle3"}},[_c('path',{attrs:{"d":"M16.49.1v10H0V.1zM39.05 0v10H22.56V0zM61.61.09v10H45.12v-10z"}})])])
          )
        }
      }
    